import { createAction, createReducer, on } from "@ngrx/store";
import { IError } from "../models/error.model";

export const setWarningText = createAction('[Warning Popup] Set Text', (text: string, status: number = 0) => ({ text, status }))

export const initialState: IError = {
  message: '',
  status: 0,
};

export const warningPopup = createReducer<IError>(
  initialState,
  on(setWarningText, (state, { text, status }) => {
    return { ...state, message: text, status }
  }),
);
